module.exports = __webpack_public_path__ + "img/juegos.720c6042.gif";